import * as React from 'react';
import type { SVGProps } from 'react';
const SvgAgent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    {...props}
  >
    <g fill="currentColor">
      <path
        fillRule="evenodd"
        d="M10.014 3.318a1 1 0 0 1 1 1v1.643h2.563a2 2 0 0 1 2 2v6.7c0 1.104-.896 2-2 2H6.423a2 2 0 0 1-2-2V7.96a2 2 0 0 1 2-2h2.59V4.319a1 1 0 0 1 1-1M7.75 8.797a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3m4.5 0a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3"
        clipRule="evenodd"
      />
      <path d="M3.625 13.139h-.97a1 1 0 0 1-1-1V9.508a1 1 0 0 1 1-1h.97zM17.347 8.508a1 1 0 0 1 1 1v2.63a1 1 0 0 1-1 1h-.971v-4.63z" />
    </g>
  </svg>
);
export default SvgAgent;
